module.exports = "/assets/footer/rewards/food_business_awards.png?JgNC7x4";